import { ProcessListItemDto, ProcessSearchRequestDto } from '@/api/generated';
import {
  processStatusOptionsTranslation,
  ProcessStatusTranslation,
} from '@/assets/locales/utils/dictionaries/dictionaries.translation.pl.ts';

export type ProcessesTranslation = {
  components: {
    hideRealizationDetails: {
      show: string;
      showTooltip: string;
    };
  };
  header: {
    button: {
      add: string;
      addByForm: string;
    };
  };
  table: {
    body: Record<keyof Omit<ProcessListItemDto, 'processId' | 'updatedAt'>, string> & {
      processStatusOptions: ProcessStatusTranslation;
    };
    details: {
      contacts: string;
      customer: string;
      description: string;
      eventType: string;
      inquirySource: string;
      noContacts: string;
      noCustomer: string;
      open: string;
      updatedAt: string;
    };
    head: Record<keyof Omit<ProcessSearchRequestDto, 'isNeedingAttention'>, string> & {
      processStatusOptions: ProcessStatusTranslation;
    };
    quickFilters: {
      canceled: string;
      createdByMe: string;
      finished: string;
      inProgress: string;
      last7Days: string;
      mine: string;
      needsAction: string;
      needsActionTooltip: string;
      statusNew: string;
      today: string;
    };
  };
};

export const processesTranslation: ProcessesTranslation = {
  components: {
    hideRealizationDetails: {
      show: 'Pokaż: {{label}}',
      showTooltip: 'Szczegóły realizacji są ukryte — kliknij, żeby je pokazać',
    },
  },
  header: {
    button: {
      add: 'Utwórz proces',
      addByForm: 'Formularz — wypełnię sam',
    },
  },
  table: {
    body: {
      createdAt: 'Data utworzenia',
      creator: 'Rozpoczęty przez',
      customer: 'Klient',
      inquirySource: 'Źródło zapytania',
      name: 'Nazwa',
      owner: 'Właściciel',
      processStatusOptions: processStatusOptionsTranslation,
      status: 'Status',
    },
    details: {
      contacts: 'Osoby do kontaktu',
      customer: 'Klient',
      description: 'Opis',
      eventType: 'Typ wydarzenia',
      inquirySource: 'Źródło zapytania',
      noContacts: 'Brak osób do kontaktu',
      noCustomer: 'Bez przypisanego klienta',
      open: 'Otwórz proces',
      updatedAt: 'Ostatnia zmiana',
    },
    head: {
      createdFrom: 'Rozpoczęty po',
      createdTo: 'Rozpoczęty przed',
      customerId: 'Klient',
      fullTextSearchInput: 'Wyszukaj',
      inquirySources: 'Źródło zapytania',
      processContactId: 'Osoba do kontaktu',
      processCreatorId: 'Rozpoczęty przez',
      processOwnerId: 'Właściciel',
      processStatusOptions: processStatusOptionsTranslation,
      statuses: 'Statusy',
      updatedFrom: 'Ostatnia aktualizacja po',
      updatedTo: 'Ostatnia aktualizacja przed',
    },
    quickFilters: {
      canceled: 'Anulowane',
      createdByMe: 'Rozpoczęte przeze mnie',
      finished: 'Zakończone',
      inProgress: 'W trakcie',
      last7Days: 'Ostatnie 7 dni',
      mine: 'Tylko moje',
      needsAction: 'Wymagają działania',
      needsActionTooltip: 'Moje procesy z zadaniami na dziś lub po terminie',
      statusNew: 'Nowe',
      today: 'Z dzisiaj',
    },
  },
};
